import { inject, Pipe, PipeTransform } from '@angular/core';
import { DiaryLogType, LanguageService } from '../../core';


/**
 * Pipe to map diary message.
 */
@Pipe({
	name: 'diaryMessage'
})
export class DiaryMessagePipe implements PipeTransform {

	private readonly langSrv = inject(LanguageService);


	transform(subType: string | undefined, type: DiaryLogType): string | null {
		if (!subType) return null;
		switch (type) {
			case DiaryLogType.MotivationalMessageRead: return subType;
			case DiaryLogType.MotivationalMessageFlag: {
				return subType === 'True' ? this.langSrv.labels().LOG_MESSAGE_MOTMESSAGE_ENABLED : this.langSrv.labels().LOG_MESSAGE_MOTMESSAGE_DISABLED;
			}
			case DiaryLogType.AppStateChanged: {
				switch (subType) {
					case 'Unknown': return this.langSrv.labels().LOG_MESSAGE_APPSTATE_UNKNOWN;
					case 'Anonymous': return this.langSrv.labels().LOG_MESSAGE_APPSTATE_ANONYMOUS;
					case 'Synced': return this.langSrv.labels().LOG_MESSAGE_APPSTATE_SYNCED;
					case 'SyncPending': return this.langSrv.labels().LOG_MESSAGE_APPSTATE_PENDING;
					case 'Outdated': return this.langSrv.labels().LOG_MESSAGE_APPSTATE_OUTDATED;
					default: return null;
				}
			}
			default: return null;
		}
	}

}
